/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBellPause = createReactComponent("outline", "bell-pause", "IconBellPause", [["path", { "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 4.022 2.821", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

export { IconBellPause as default };
//# sourceMappingURL=IconBellPause.mjs.map
